import type { PrivilegeDefinition } from './SecurityTypes';

export class SecurityRegistry {
  private static instance: SecurityRegistry | null = null;

  private readonly privileges = new Map<string, PrivilegeDefinition>();
  private locked = false;

  private constructor() {}

  public static getInstance(): SecurityRegistry {
    if (!SecurityRegistry.instance) {
      SecurityRegistry.instance = new SecurityRegistry();
    }
    return SecurityRegistry.instance;
  }

  public registerFeature(feature: { name: string; privileges?: PrivilegeDefinition[] }): void {
    if (this.locked) {
      throw new Error('SecurityRegistry is locked. Cannot register more privileges.');
    }
    const privileges = feature.privileges ?? [];
    privileges.forEach((definition) => this.registerPrivilege(definition, feature.name));
  }

  public registerPrivilege(definition: PrivilegeDefinition, featureName?: string): void {
    if (this.locked) {
      throw new Error('SecurityRegistry is locked. Cannot register more privileges.');
    }
    const trimmedId = definition.id.trim();
    if (!trimmedId) {
      const owner = featureName ? ` from feature "${featureName}"` : '';
      throw new Error(`Privilege id is required${owner ? owner : ''}`);
    }
    if (this.privileges.has(trimmedId)) {
      const owner = featureName ? ` via feature "${featureName}"` : '';
      throw new Error(`Duplicate privilege registration "${trimmedId}"${owner}`);
    }
    this.privileges.set(trimmedId, {
      ...definition,
      id: trimmedId,
    });
  }

  public lock(): void {
    this.locked = true;
  }

  public getAllPrivileges(): PrivilegeDefinition[] {
    return Array.from(this.privileges.values());
  }

  public getPrivilege(privilegeId: string): PrivilegeDefinition | null {
    return this.privileges.get(privilegeId) ?? null;
  }

  public hasPrivilege(privilegeId: string): boolean {
    return this.privileges.has(privilegeId);
  }
}
